import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';
import { ru } from 'date-fns/locale';
import { DateRange } from 'react-day-picker';

export function stringToDateRange(value?: string | null): DateRange | undefined {
  if (!value) return;
  const [from, to] = value.split(',');
  return {
    from: new Date(from),
    to: to ? new Date(to) : undefined,
  };
}

export function dateRangeToISOString(value?: DateRange | null): string | undefined {
  const from = toISODateString(value?.from);
  const to = toISODateString(value?.to);
  if (!from) return;
  if (to && to != from) return `${from},${to}`;
  return from;
}

export function dateRangeToDateFilter(value?: DateRange | null): string | undefined {
  const from = value?.from ? format(value.from, 'yyyy-MM-dd') : undefined;
  const to = value?.to ? format(value.to, 'yyyy-MM-dd') : undefined;
  if (!from) return;
  if (to && to !== from) return `${from},${to}`;
  return from;
}

export function dateRangeToString(value?: DateRange | null): string | undefined {
  const from = toDateString(value?.from?.toISOString());
  const to = toDateString(value?.to?.toISOString());
  if (!from) return;
  if (to && to != from) return `${from}-${to}`;
  return from;
}

export function formatDateRangeISOString(value?: string | null): string | undefined {
  if (!value) return;
  let [from, to]: (string | undefined)[] = value.split(',');
  from = toDateString(from);
  to = toDateString(to);
  if (!from) return;
  if (to && to != from) return `${from}-${to}`;
  return from;
}

export function toISODateString(value?: Date, tz?: number): string | undefined {
  try {
    return value ? new TZDate(value, timezoneToStringOffset(tz)).toISOString() : undefined;
  } catch {
    return;
  }
}

export function toDateString(value?: string, tz?: number): string | undefined {
  try {
    return value ? format(new TZDate(value, timezoneToStringOffset(tz)), 'dd.MM.yy', { locale: ru }) : undefined;
  } catch {
    return;
  }
}

export function toDateTimeString(value?: string, tz?: number): string | undefined {
  try {
    return value ? format(new TZDate(value, timezoneToStringOffset(tz)), 'HH:mm, dd.MM.yy', { locale: ru }) : undefined;
  } catch {
    return;
  }
}

export function timezoneToStringOffset(tz?: number) {
  if (typeof tz === 'undefined') return;
  if (tz < 0) {
    return `-${tz.toString().slice(1).padStart(2, '0')}:00`;
  }
  return `+${tz.toString().padStart(2, '0')}:00`;
}
